export const GET_GLOBAL_IAAC = "get_global_iaac";
export const GET_GLOBAL_IAAC_SUCCESSFUL = "get_global_iaac_successful";
export const GET_GLOBAL_IAAC_FAILURE = "get_global_iaac_failure";
export const PUT_GLOBAL_IAAC = "put_global_iaac";
export const PUT_GLOBAL_IAAC_SUCCESSFUL = "put_global_iaac_successful";
export const PUT_GLOBAL_IAAC_FAILURE = "put_global_iaac_failure";
export const CLEAR_ALL_GLOBAL_IAAC_MESSAGES = "clear_all_global_iaac_messages";
export const CLEAR_ALL_GLOBAL_IAAC_MESSAGES_SUCCESSFUL = "clear_all_global_iaac_messages_successful";
